
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { GetStaticProps } from "next"
import Head from "next/head"

import getFilters from "@/graphql/requests/getFilters"
import Default from "@/templates/Default"
import FansiKind from "@/ts/enums/global/FansiKind"
import ProductType from "@/ts/enums/product/ProductType"
import FilterGroup from "@/ts/interfaces/global/FilterGroup"
import SearchView from "@/views/search"
import useStaticProducts from "@/views/search/functions/useStaticProducts"

const productType = ProductType.Digital
const fansiKind = FansiKind.Digital

function SearchPage({ staticFilters }: { staticFilters: FilterGroup }) {
  const { filters } = useStaticProducts({ staticFilters, productType })

  if (!filters) return null

  return (
    <>
      <Head>
        <title>Wyszukiwanie | fansi.pl</title>
      </Head>
      <SearchView
        filters={filters as any}
        productType={productType}
        fansiKind={fansiKind}
      />
    </>
  )
}

SearchPage.Layout = Default

 const _getStaticProps: GetStaticProps = async () => {
  const staticFilters = await getFilters({ type: productType })
  return { props: { staticFilters }, revalidate: 1 }
}

export default SearchPage


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/search',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  